import { fishDatabase } from "../data/fish_db";

export default function TestPage() {

  // Simplified fish list from fishDatabase with only id, names, scientific name, and nutrients
  const simplifiedFishList = fishDatabase.map(fish => ({
    id: fish.id,
    local_name: fish.local_name,
    english_name: fish.english_name,
    scientific_name: fish.scientific_name,
    nutrients_per_100g: fish.nutrients_per_100g_fallback
  }));

  // Log the simplified fish list to the console
  console.log("Simplified Fish List:", simplifiedFishList);
  //copy the json to clipboard
  navigator.clipboard.writeText(JSON.stringify(simplifiedFishList, null, 2));

  return (
    <div>
      <h1>Test Page</h1>
      <p>This is a test page.</p>
    </div>
  );
}
